import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { 
  faSearch, 
  faImage, 
  faTimes, 
  faUser, 
  faCog,
  faTrash,
  faPlus,
  faTag,
  faDollarSign,
  faEdit,
  faLink,
  faEllipsisH,
  faCheckCircle,
  faClock,
  faArchive
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faSearch, faImage, faTimes, faUser, faCog, faTrash, faPlus, faTag, faDollarSign, faEdit, faLink, faEllipsisH, faCheckCircle, faClock, faArchive
)

export { FontAwesomeIcon }
